import {
  type APITriplet,
  type ModelTriplet,
  RDK_MODEL_NAME_BUILTIN,
} from '$lib/resource-type';

import { isBuiltinAPI } from './api-types';
import { isBuiltinModel } from './models';
import { ServiceSubtypes } from './services';

export const isBuiltinMotionService = (api: APITriplet, model: ModelTriplet) =>
  isBuiltinAPI(api, ServiceSubtypes.MOTION) &&
  isBuiltinModel(model, RDK_MODEL_NAME_BUILTIN);
